import { message } from "antd";
import apiHelper from "./apiHelper";

export const runComputation = async ({
  nPhotons,
  nModes,
  nEvents,
  unitaryType
}: {
  nPhotons: string;
  nModes: string;
  nEvents: string;
  unitaryType: string;
}) => {
  const url = `/playground/${nPhotons}/${nModes}/${nEvents}/${unitaryType}`;
  const res = await apiHelper.get(url, {});

  if (res?.data.statusCode === 200) {
    return { success: true, data: res.data };
  }
  return { error: true, message: res?.data.message };
};

export const getCredentials = async () => {
  try {
    const url = "/configure";
    const res = await apiHelper.get(url, {});
    return res;
  } catch (error) {
    message.error("Could not fetch Job credentials");
    return null;
  }
};
